module.exports = __webpack_public_path__ + "static/img/preview-04.b84e6958.webp";